import"./src/styles/global.scss";/**
 * Gatsby Browser APIs
 * Import global styles and configure client-side behavior
 */// Wrap the root element (useful for providers, themes, etc.)
export const wrapRootElement=_ref=>{let{element}=_ref;return element;};